















import { Component, Vue, Prop } from 'nuxt-property-decorator'
import PostItem from '~/components/Post/PostItem.vue'

@Component({
  name: 'PostList',
  components: { PostItem }
})
export default class extends Vue {
  @Prop() list
  @Prop() section
}
